import type { TimingsPayload } from '@/app/api/search/timings/route';
import { API_NAME } from '@/app/components/search/common/apiTypes.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { ENVIRONMENT_NAME, getEnvironment } from '@/server/environment.ts';
import type { CuriosityParams } from '../../Curiosity';
import getSearchParams from '../../common/getSearchParams';
import { TIMING_NAME } from './timingsTypes';
import type { Localization } from '../../common/Localization';
import clientAPICall from '../../common/clientAPICall.ts';

type LogClientSidePerformance = {
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
  searchInfoData: SearchInfoData;
};

type TimingsResponse = object;

const normaliseTiming = (timing: number): number => Math.abs(timing);

export const logClientSideTimings = async ({
  commonData,
  localization,
  curiosityParams,
  searchInfoData,
}: LogClientSidePerformance) => {
  const { searchMode, searchId } = searchInfoData;
  const { userUid, sessionId, isBot } = commonData;
  const { timingPerformances } = curiosityParams;
  const now = new Date().getTime();
  // @ts-ignore
  const clientFE = now - (window.openx?.feTimingStart || 0);

  try {
    const [perf] = performance.getEntriesByType('navigation');
    // @ts-ignore
    timingPerformances[TIMING_NAME.CLIENT_FE] = { elapsed: normaliseTiming(clientFE) };
    // @ts-ignore
    timingPerformances[TIMING_NAME.CLIENT_REQUEST_START] = { elapsed: normaliseTiming(perf.requestStart) };
    // @ts-ignore
    timingPerformances[TIMING_NAME.CLIENT_RESPONSE_START] = { elapsed: normaliseTiming(perf.responseStart) };
    // @ts-ignore
    timingPerformances[TIMING_NAME.CLIENT_RESPONSE_END] = { elapsed: normaliseTiming(perf.responseEnd) };
    // @ts-ignore
    timingPerformances[TIMING_NAME.CLIENT_DOM_INTERACTIVE] = { elapsed: normaliseTiming(perf.domInteractive) };
  } catch (e) {
    console.error('Error logging timings', e);
  }

  const queryParams = getSearchParams();
  const timingSearchId = queryParams?.[URLParameters.SEARCH_ID] || searchId;
  const requestUrl = window.location.href;
  const payload: TimingsPayload = {
    environment: getEnvironment(ENVIRONMENT_NAME.APP, localization?.environments),
    searchMode,
    userId: userUid,
    sessionId,
    searchId: timingSearchId || '',
    requestUrl,
    timingPerformances,
    isBot,
    curiosityEventsEnabled: localization.configValuesApp.curiosityEventsEnabled,
  };
  await clientAPICall<TimingsPayload, TimingsResponse>({
    apiName: API_NAME.TIMINGS,
    payload,
    traceParent: searchInfoData.searchTraceParent,
    commonData,
  });
};
